import React from 'react';
import type { ReactNode } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { getTheme } from './theme';
import type { ThemeMode } from './theme';
import { ThemeContext } from './ThemeContext';
import type { ThemeContextType } from './ThemeContext';
import { RTLProvider } from './RTLProvider';
import { useRTL } from './useRTL';

interface ThemeProviderProps {
  children: ReactNode;
  defaultMode?: ThemeMode;
}

const ThemeProviderInner: React.FC<ThemeProviderProps> = ({ children }) => {
  const { direction } = useRTL();

  // Always use light mode - no dark theme support
  const mode: ThemeMode = 'light';

  const setMode = () => {
    // No-op: dark theme is not supported
    console.warn('Dark theme is not supported');
  };

  const toggleMode = () => {
    // No-op: dark theme is not supported
    console.warn('Dark theme is not supported');
  };

  const theme = getTheme(mode, direction);

  const contextValue: ThemeContextType = {
    mode,
    toggleMode,
    setMode,
  };

  return (
    <ThemeContext.Provider value={contextValue}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};

export const ThemeProvider: React.FC<ThemeProviderProps> = props => {
  return (
    <RTLProvider>
      <ThemeProviderInner {...props} />
    </RTLProvider>
  );
};
